export const CREATED_SUCCESS:string = 'Created Successfully';
export const UPDATE_SUCCESS:string = 'Updated Successfully';